var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 287.74 272.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #e118ff;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #c515e0;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.34,
    y1: 135.65,
    x2: 287.35,
    y2: 145.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#2300ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 52.75,
    y1: 182.63,
    x2: 275.27,
    y2: 186.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2300ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14008c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m283.92,128.39c5.1,2.55,5.1,9.82,0,12.37l-117.29,58.65-58.94,29.48-35.36,17.68-51,25.5c-4.12,2.06-9.1-.42-9.9-4.95C-3.27,183.82-3.91,104.23,10.21,11.74,11.63,2.47,21.7-2.72,30.08,1.47l34.59,17.3c4.69,2.34,7.65,7.13,7.65,12.37v138.33c0,5.14,5.41,8.49,10.01,6.19l25.36-12.68,58.94-29.48,35.36-17.68,25.31-12.65c1.95-.97,4.24-.97,6.18,0l27.44,13.72,22.99,11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m178.12,75.49c5.1,2.55,5.1,9.82,0,12.37l-11.49,5.74-48.93,24.47c-4.6,2.3-10.01-1.04-10.01-6.19v-60.42c0-5.14,5.41-8.48,10.01-6.19l48.93,24.46,11.49,5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m275.08,134.2L53.77,238.74l219.58-108.14c.99-.49,2.19-.08,2.68.91.49.99.08,2.19-.91,2.68,0,0-.02.01-.03.01Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 113.46,
    y1: 51.48,
    x2: 113.46,
    y2: 111.87
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset2);
export default __webpack_public_path__ + "static/media/Asset 2.6b4cb9029e864c438f43ac52de9dac7b.svg";
export { ForwardRef as ReactComponent };